const ja = {
  companyName: 'YOUNG SQUARE CREATECH',
  edit: 'データを修正します',
  userTrackingAct: {
    description1: "会場での資料収集にご協力します",
    description2: "ブランド資料を迅速に交換します",
    description3: "イベント資料の当日送付を自動化します",
    description4: "フォローもコンタクトも簡単です",
    description5: "資料は何度も記入する必要はありません",
    description6: "ブランド資料をペーパーレス化して送付します",
    next: '使ってみましょう',
    next1: '次へ',
    declarationTitle: '個人情報使用に関する声明',
    declarationDetail1: '個人情報保護法など関連規則に基づき本サービスは以下の事項を告知する義務を負う。',
    declarationDetail2: '１Clickの「',
    declarationDetail3: '」のペーパーレスビジネス情報エクスプレスサービスのご利用に同意したユーザーは、「ユーザー情報」が「',
    declarationDetail4: '」に提供され、その個人データの使用期間、対象、地域、および方法は、主にシステムまたは組織の「プライバシーに関する告知」に基づいており、今回収集された個人情報は、「',
    declarationDetail5: '」のみ使用することができ、また、個人情報保護法関連規則を遵守し、ユーザーの個人情報を保護するものとする。',
    termOfUse1: '同意します',
    termOfUse2: '利用規則に同意する',
    termOfUse3: 'この欄は必ずチェックを入れてください。チェックがない場合、このサービスの申し込みも使用もできません。',
    termOfUse4: '',
    requestFor1: 'ブランドデータをリクエストします（連絡先情報/デジタルカタログなどの関連データ）。',
    requestFor2: 'ブランド資料は、入場日当日の展示会/イベント終了後、リクエスト記録を自動的にまとめてお客様のご記入なさったメールアドレスに送信します。',
    confirm: '確認',
    inputNotice: 'ブランド連絡先情報や製品/サービスデジタルカタログを入手する場合は、以下の情報を入力してください。',
    userName: '氏名',
    userNamePlaceHolder: '氏名をを入力してください',
    userEmail: 'メールアドレス',
    userEmailNotice: '展示会資料が受信できるメールアドレスを記入してください',
    userEmailPlaceHolder: 'メールアドレスを入力してください',
    userPhone: '携帯電話番号',
    userPhonePlaceHolder: '携帯電話番号を入力してください',
    userCompany: '会社名',
    userCompanyPlaceHolder: '会社名を入力してください',
    userJobTitle: '職種',
    userJobTitlePlaceHolder: 'あなたの職種は？',
    userIndustry: '業種',
    userIndustryPlaceHolder: 'あなたの会社(または団体)の業種は？',
    back: '前へ',
  },
  userTrackingResult: {
    description1: 'ブランド関連資料取得に１Clickをご利用いただきありがとうございます。リクエストなさった展示会資料は、入場日当日の展示会/イベント終了後に、リクエスト記録を自動的にまとめてお客様のご記入なさったメールアドレスに送信します。',
    openAttachment: 'ブランド電子カタログを開くにはここをクリックしてください',
  },
  visitorReport: {
    description1: 'この度は「',
    description2: '」にて１Clickビジネス情報エクスプレスサービスをご利用いただきありがとうございます。以下はイベント期間中に訪問なさったブランドブースリストと電子カタログのリンクです。',
    description3: '',
    description4: ': 訪問リスト',
    description5: '日付: ',
    col1: '訪問時間',
    col2: '会社名',
    col3: '氏名',
    col4: '電話番号',
    col5: 'メールアドレス',
    col6: '電子カタログ',
    link: 'リンク',
  },
  boothReport: {
    description1: '，１Clickビジネス情報エクスプレスサービスをご利用いただきありがとうございます。以下は貴ブースご来場者のリストと電子カタログリストをリクエストした方のリストとなります。',
    description2: '',
    description3: ': 訪問者リスト',
    description4: '日付: ',
    col1: '訪問時間',
    col2: '会社名',
    col3: '業種',
    col4: '氏名',
    col5: '職位',
    col6: '電話番号',
    col7: 'メールアドレス',
  },
};

export default ja;
